"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRessourceTypes = exports.getMineStandType = exports.getTrailerStandType = exports.sumResources = exports.ResourcesDTO = exports.ProducedResourcesDTO = exports.ResourceTypesDTO = exports.ResourceTypes = exports.StandTypes = void 0;
const class_validator_1 = require("class-validator");
var StandTypes;
(function (StandTypes) {
    StandTypes["Farm"] = "Farm";
    StandTypes["FoodTrailer"] = "FoodTrailer";
    StandTypes["Sawmill"] = "Sawmill";
    StandTypes["WoodTrailer"] = "WoodTrailer";
    StandTypes["Quarry"] = "Quarry";
    StandTypes["BrickTrailer"] = "BrickTrailer";
    StandTypes["Foundry"] = "Foundry";
    StandTypes["MetalTrailer"] = "MetalTrailer";
    StandTypes["Van"] = "Van";
    StandTypes["Dormitory"] = "Dormitory";
    StandTypes["MappingCenter"] = "MappingCenter";
})(StandTypes = exports.StandTypes || (exports.StandTypes = {}));
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["Food"] = "Food";
    ResourceTypes["Wood"] = "Wood";
    ResourceTypes["Brick"] = "Brick";
    ResourceTypes["Metal"] = "Metal";
    ResourceTypes["Gas"] = "Gas";
    ResourceTypes["Antidote"] = "Antidote";
    ResourceTypes["ManualsAmazon"] = "ManualsAmazon";
    ResourceTypes["ManualsBrute"] = "ManualsBrute";
    ResourceTypes["ManualsMedic"] = "ManualsMedic";
    ResourceTypes["ManualsRanger"] = "ManualsRanger";
})(ResourceTypes = exports.ResourceTypes || (exports.ResourceTypes = {}));
class ResourceTypesDTO {
}
exports.ResourceTypesDTO = ResourceTypesDTO;
let ProducedResourcesDTO = (() => {
    class ProducedResourcesDTO {
        constructor() {
            this.food = 0;
            this.wood = 0;
            this.brick = 0;
            this.metal = 0;
            this.gas = 0;
        }
    }
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ProducedResourcesDTO.prototype, "food", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ProducedResourcesDTO.prototype, "wood", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ProducedResourcesDTO.prototype, "brick", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ProducedResourcesDTO.prototype, "metal", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ProducedResourcesDTO.prototype, "gas", void 0);
    return ProducedResourcesDTO;
})();
exports.ProducedResourcesDTO = ProducedResourcesDTO;
let ResourcesDTO = (() => {
    class ResourcesDTO extends ProducedResourcesDTO {
        constructor() {
            super(...arguments);
            this.antidote = 0;
            this.manualsAmazon = 0;
            this.manualsBrute = 0;
            this.manualsMedic = 0;
            this.manualsRanger = 0;
            this.civilians1 = 0;
            this.civilians2 = 0;
            this.civilians3 = 0;
        }
    }
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "antidote", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "manualsAmazon", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "manualsBrute", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "manualsMedic", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "manualsRanger", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "civilians1", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "civilians2", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], ResourcesDTO.prototype, "civilians3", void 0);
    return ResourcesDTO;
})();
exports.ResourcesDTO = ResourcesDTO;
function sumResources(res1, res2) {
    return {
        food: res1.food + res2.food,
        wood: res1.wood + res2.wood,
        brick: res1.brick + res2.brick,
        metal: res1.metal + res2.metal,
        antidote: res1.antidote + res2.antidote,
        gas: res1.gas + res2.gas,
        manualsAmazon: res1.manualsAmazon + res2.manualsAmazon,
        manualsBrute: res1.manualsBrute + res2.manualsBrute,
        manualsMedic: res1.manualsMedic + res2.manualsMedic,
        manualsRanger: res1.manualsRanger + res2.manualsRanger,
        civilians1: res1.civilians1 + res2.civilians1,
        civilians2: res1.civilians2 + res2.civilians2,
        civilians3: res1.civilians3 + res2.civilians3
    };
}
exports.sumResources = sumResources;
function getTrailerStandType(resourceTypes) {
    switch (resourceTypes) {
        case ResourceTypes.Food:
            return StandTypes.FoodTrailer;
        case ResourceTypes.Wood:
            return StandTypes.WoodTrailer;
        case ResourceTypes.Brick:
            return StandTypes.BrickTrailer;
        case ResourceTypes.Metal:
            return StandTypes.MetalTrailer;
        default:
            return null;
    }
}
exports.getTrailerStandType = getTrailerStandType;
function getMineStandType(resourceTypes) {
    switch (resourceTypes) {
        case ResourceTypes.Food:
            return StandTypes.Farm;
        case ResourceTypes.Wood:
            return StandTypes.Sawmill;
        case ResourceTypes.Brick:
            return StandTypes.Quarry;
        case ResourceTypes.Metal:
            return StandTypes.Foundry;
        default:
            return null;
    }
}
exports.getMineStandType = getMineStandType;
function getRessourceTypes(standType) {
    switch (standType) {
        case StandTypes.Farm:
            return ResourceTypes.Food;
        case StandTypes.FoodTrailer:
            return ResourceTypes.Food;
        case StandTypes.Sawmill:
            return ResourceTypes.Wood;
        case StandTypes.WoodTrailer:
            return ResourceTypes.Wood;
        case StandTypes.Quarry:
            return ResourceTypes.Brick;
        case StandTypes.BrickTrailer:
            return ResourceTypes.Brick;
        case StandTypes.Foundry:
            return ResourceTypes.Metal;
        case StandTypes.MetalTrailer:
            return ResourceTypes.Metal;
        case StandTypes.Van:
            return null;
        case StandTypes.Dormitory:
            return null;
        case StandTypes.MappingCenter:
            return null;
    }
    return null;
}
exports.getRessourceTypes = getRessourceTypes;
//# sourceMappingURL=Resources.js.map